var currentPage = 0;

$(window).load(function () {

    window.router = peopleRouter;
    router.init();

    if (window.initialSearchState) {
        handlePeoplePopstate(window.initialSearchState, false, false)
    }
    else
        getSearchResults("", "", true);
});

function handlePeoplePopstate(filters, isEmptySearch, dontFadeResults) {
    if (isEmptySearch) {
        console.log('empty search')
        resetSearchResults();
        resetViewMoreButton();
        clearAllOptions();
        noFilterSelected();
    }
    else {
        resetSearchResults();
        resetViewMoreButton();
        clearAllOptions();
        noFilterSelected(dontFadeResults);

        if (filters.keyword) {
            $("#KeywordInput").val(filters.keyword);
        }

        if (filters.letter) {
            $(".list-alpha-link[data-filter='" + filters.letter + "']").addClass("is-selected");
        }

        if (filters.industries.length) {
            $.each(filters.industries, function (i, industry) {
                $("#IndustryUl button[data-name='" + industry + "']").addClass("is-selected");
            });
        }

        if (filters.practices.length) {
            $.each(filters.practices, function (i, practice) {
                $("#PracticeUl button[data-name='" + practice + "']").addClass("is-selected");
            });
        }

        if (filters.offices.length) {
            $.each(filters.offices, function (i, office) {
                $("#OfficeUl button[data-name='" + office + "']").addClass("is-selected");
            });
        }

        //get the dropdown filters by their text, not value, because its what the url is storing (to look pretty, guids are not pretty)
        if (filters.level) {
            $("#TitleDropDown").val(getDropdownByText("#TitleDropDown option", filters.level).val());
            $("#TitleLabel").updateSelected("#TitleDropDown", "Title", false);
        }

        if (filters.license) {
            $("#LicenseDropDown").val(getDropdownByText("#LicenseDropDown option", filters.license).val());
            $("#LicenseLabel").updateSelected("#LicenseDropDown", "License", false);
        }

        if (filters.language) {
            $("#LanguageDropDown").val(getDropdownByText("#LanguageDropDown option", filters.language).val());
            $("#LanguageLabel").updateSelected("#LanguageDropDown", "Language", false);
        }

        if (filters.page) {
            currentPage = filters.page;
        }

        getSearchResults("", filters.sort, true);
    }
}

$(document.body).on("change", "#TitleDropDown", function () {
    $("#TitleLabel").updateSelected("#TitleDropDown", "Title", true);
});

$(document.body).on("change", "#LicenseDropDown", function () {
    $("#LicenseLabel").updateSelected("#LicenseDropDown", "License", true);
});

$(document.body).on("change", "#LanguageDropDown", function () {
    $("#LanguageLabel").updateSelected("#LanguageDropDown", "Language", true);
});

(function ($) {
    $.fn.updateSelected = function (dropDown, defaultValue, updateSearch) {
        resetSearchResults();
        resetViewMoreButton();
        var newText = "";

        if ($("option:selected", dropDown).text() !== "") {
            newText = $("option:selected", dropDown).text();
        } else {
            newText = defaultValue;
        };

        $(this).text(newText);
        if (updateSearch) {
            getSearchResults("", "");
        }
        return this;
    };
})(jQuery);

function printPerson(div, item) {
    div.append("<div class='person'>" +
        "<div class='person-img'>" +
        "<img src='" + item.Image + "'>" +
        "</div>" +
        "<div class='person-info'>" +
        "<h2 class='person-title'><a href=" + item.Link + ">" + item.Name + "</a></h2>" +
        "<span class='person-snapshot-title'>" + item.Position + "</span>" +
        "<p>" + item.OfficeString + "</p>" +
        "<p class='person-email'><a href='\mailto:" + item.Email + "'>" + item.Email + "</a></p>" +
        "</div>" +
        "</div>");
}

function printSelectedOptions(queryNameKeyword, queryNameLastNameStart, queryNameIndustry, queryNamePractice, queryNameOffice, queryNameLevel, queryNameLicense, queryNameLanguage, queryNameSort, div) {
    var sortDiv = "#search-criteria-filters";
    $(div).empty();
    $(sortDiv).empty();

    if (queryNameKeyword !== "") {
        div.append("<button class='search-criteria-item' onclick='clearSelectedOption(this)' data-filter='queryNameKeyword'>" + queryNameKeyword + "<i class='fa fa-plus-circle'></i></button>");
    }
    if (queryNameLastNameStart !== "") {
        div.append("<button class='search-criteria-item' onclick='clearSelectedOption(this)' data-filter='queryNameLastNameStart'>" + queryNameLastNameStart + "<i class='fa fa-plus-circle'></i></button>");
    }
    if (queryNameIndustry.length > 0) {
        $.each(queryNameIndustry, function (index, value) {
            div.append("<button class='search-criteria-item' onclick='clearSelectedOption(this)' data-filter='queryNameIndustry' data-value='" + value.key + "'>" + value.text + "<i class='fa fa-plus-circle'></i></button>");
        });
    }
    if (queryNamePractice.length > 0) {
        $.each(queryNamePractice, function (index, value) {
            div.append("<button class='search-criteria-item' onclick='clearSelectedOption(this)' data-filter='queryNamePractice' data-value='" + value.key + "'>" + value.text + "<i class='fa fa-plus-circle'></i></button>");
        });
    }
    if (queryNameOffice.length > 0) {
        $.each(queryNameOffice, function (index, value) {
            div.append("<button class='search-criteria-item' onclick='clearSelectedOption(this)' data-filter='queryNameOffice' data-value='" + value.key + "'>" + value.text + "<i class='fa fa-plus-circle'></i></button>");
        });
    }
    if (queryNameLevel !== "") {
        div.append("<button class='search-criteria-item' onclick='clearSelectedOption(this)' data-filter='queryNameLevel'>" + queryNameLevel + "<i class='fa fa-plus-circle'></i></button>");
    }
    if (queryNameLicense !== "") {
        div.append("<button class='search-criteria-item' onclick='clearSelectedOption(this)' data-filter='queryNameLicense'>" + queryNameLicense + "<i class='fa fa-plus-circle'></i></button>");
    }
    if (queryNameLanguage !== "") {
        div.append("<button class='search-criteria-item' onclick='clearSelectedOption(this)' data-filter='queryNameLanguage'>" + queryNameLanguage + "<i class='fa fa-plus-circle'></i></button>");
    }
    if (queryNameLastNameStart !== "" || queryNameKeyword !== "" || queryNameIndustry.length > 0 || queryNamePractice.length > 0 || queryNameOffice.length > 0 || queryNameLevel !== "" || queryNameLicense !== "" || queryNameLanguage !== "" || queryNameSort !== "") {
        div.append("<button class='btn btn-clear' onclick='clearAllOptionsButtonClicked()'>" + clearFiltersLabel + "</button></div>");
        $(sortDiv).append("<span class='search-criteria-label'>" + sortLabel + "</span>" +
            "<button id='lNameSort' name='lNameSort' data-filter='lnameSort' onclick='sortClicked(this)' class='search-criteria-filter-item'>A-Z</button>" +
            "<button id='titleSort' name='titleSort' data-filter='titleSort' onclick='sortClicked(this)' class='search-criteria-filter-item'>Title</button>" +
            "<button id='officeSort' name='officeSort' data-filter='officeSort' onclick='sortClicked(this)' class='search-criteria-filter-item'>Office</button>");

        switch (queryNameSort) {
            case "titleSort":
                $("#titleSort").addClass("is-active");
                break;
            case "officeSort":
                $("#officeSort").addClass("is-active");
                break;
            default:
                $("#lNameSort").addClass("is-active");
                break;
        }
    }
}

function animateResults() {
    var peopleHighlightsWrapper = $(".people-results-highlights"),
        peopleResultsWrapper = $(".people-results-content");

    if (peopleHighlightsWrapper.length > 0) {
        peopleHighlightsWrapper.fadeOut(function () {
            peopleResultsWrapper.fadeIn().addClass("active-results");
        });
    }
    else {
        peopleResultsWrapper.fadeIn().addClass("active-results");
    }
}

function letterClicked(target) {
    resetSearchResults();
    resetViewMoreButton();
    clearAllOptions();
    var letter = $(target).attr("data-filter");
    $(target).addClass("is-selected");
    getSearchResults(letter, "");
}

function sortClicked(target) {
    var sortOptionItems = $("#search-criteria-filters");
    sortOptionItems.each(function (idx, button) {
        var sortButton = $(button);
        if (sortButton.hasClass("is-selected")) {
            $(sortButton).removeClass("is-selected");
        }
    });

    var sortOption = $(target).attr("data-filter");
    $(target).addClass("is-selected");
    resetSearchResults();
    resetViewMoreButton();
    getSearchResults("", sortOption);
}

function clearSelectedOption(target) {
    resetSearchResults();
    resetViewMoreButton();
    var option = $(target).attr("data-filter");
    var dropdown = "";
    var label = "";
    var defaultText = "";

    if (option === "queryNameKeyword") {
        $("#KeywordInput").val("");
        getSearchResults("", "");
    }

    if (option === "queryNameLastNameStart") {
        $(".list-alpha-link[data-filter='" + $(target).text() + "']").removeClass("is-selected");

        getSearchResults("", "");
    }

    if (option === "queryNameIndustry") {
        $("#IndustryUl button.is-selected").each(function () {
            var industryButtonValue = $(this).attr("data-filter");
            var targetValue = $(target).attr("data-value");
            if (industryButtonValue.toLowerCase() === targetValue.toLowerCase()) {
                $(this).removeClass("is-selected");
            }
        });

        getSearchResults("", "");
    }

    if (option === "queryNamePractice") {
        $("#PracticeUl button.is-selected").each(function () {
            var practiceButtonValue = $(this).attr("data-filter");
            var targetValue = $(target).attr("data-value");
            if (practiceButtonValue.toLowerCase() === targetValue.toLowerCase()) {
                $(this).removeClass("is-selected");
            }
        });

        getSearchResults("", "");
    }

    if (option === "queryNameOffice") {
        $("#OfficeUl button.is-selected").each(function () {
            var officeButtonValue = $(this).attr("data-filter");
            var targetValue = $(target).attr("data-value");
            if (officeButtonValue.toLowerCase() === targetValue.toLowerCase()) {
                $(this).removeClass("is-selected");
            }
        });

        getSearchResults("", "");
    }

    if (option === "queryNameLevel") {
        dropdown = "#TitleDropDown";
        label = "#TitleLabel";
        defaultText = "Title";
        UpdateSelectedOption(dropdown, label, defaultText, true);
    }

    if (option === "queryNameLicense") {
        dropdown = "#LicenseDropDown";
        label = "#LicenseLabel";
        defaultText = "License";
        UpdateSelectedOption(dropdown, label, defaultText, true);
    }

    if (option === "queryNameLanguage") {
        dropdown = "#LanguageDropDown";
        label = "#LanguageLabel";
        defaultText = "Language";
        UpdateSelectedOption(dropdown, label, defaultText, true);
    }

    if (option === "lnameSort" || option === "titleSort" || option === "officeSort") {
        $(target).removeClass("is-selected");
        getSearchResults("", "");
    }

    resetFilterLabels();
}

function clearAllOptions() {
    $("#KeywordInput").val("");
    $("#list-alpha a.is-selected").removeClass("is-selected");
    $("#IndustryUl button.is-selected").removeClass("is-selected");
    $("#PracticeUl button.is-selected").removeClass("is-selected");
    $("#OfficeUl button.is-selected").removeClass("is-selected");
    $(".search-criteria-filter-item.is-active").removeClass("is-active");
    UpdateSelectedOption("#TitleDropDown", "#TitleLabel", "Title", false);
    UpdateSelectedOption("#LicenseDropDown", "#LicenseLabel", "License", false);
    UpdateSelectedOption("#LanguageDropDown", "#LanguageLabel", "Language", false);
    resetFilterLabels();
}

function clearAllButKeyword() {
    $("#list-alpha a.is-selected").removeClass("is-selected");
    $("#IndustryUl button.is-selected").removeClass("is-selected");
    $("#PracticeUl button.is-selected").removeClass("is-selected");
    $("#OfficeUl button.is-selected").removeClass("is-selected");
    $(".search-criteria-filter-item.is-active").removeClass("is-active");
    UpdateSelectedOption("#TitleDropDown", "#TitleLabel", "Title", false);
    UpdateSelectedOption("#LicenseDropDown", "#LicenseLabel", "License", false);
    UpdateSelectedOption("#LanguageDropDown", "#LanguageLabel", "Language", false);
    resetFilterLabels();
}

function clearAllOptionsButtonClicked(dontFadeResults) {
    resetSearchResults();
    resetViewMoreButton();
    clearAllOptions();
    noFilterSelected(dontFadeResults);
    getSearchResults("", "", false);
}

function UpdateSelectedOption(dropdown, label, defaultText, updateSearch) {
    $(dropdown + " option").attr("selected", false);
    $(dropdown + " option:first").attr("selected", true);

    $(label).updateSelected(dropdown, defaultText, updateSearch);
}

function noFilterSelected(dontFadeResults) {
    $("#search-criteria-filters, #search-criteria-results, #people-results-list").empty();

    var peopleHighlightsWrapper = $(".people-results-highlights"),
        peopleResultsWrapper = $(".people-results-content");

    peopleResultsWrapper.removeClass("active-results");

    if (!dontFadeResults) {
        peopleResultsWrapper.fadeOut(function () {
            peopleHighlightsWrapper.fadeIn();
        });
    }
}

function multiSelectOptionClicked(target) {
    resetSearchResults();
    resetViewMoreButton();
    getSearchResults("", "");
}

function scrollToResults() {
    $("html, body").animate({
        scrollTop: $(".people-results-list").offset().top - 100
    }, 1000);
}

function execKeywordSearch() {
    resetSearchResults();
    clearAllButKeyword();
    resetViewMoreButton();
    scrollToResults();
    getSearchResults("", "");
}

function viewMoreButtonClicked() {
    currentPage++;
    getSearchResults("", "");
}

function hideViewMoreButton() {
    $("#viewMore").parent().hide();
}

function resetViewMoreButton() {
    currentPage = 0;
    $("#viewMore").parent().show();
}

function resetSearchResults() {
    $("#people-results-list").empty();
}


function handleQuote(str) {
    var result = str.replace("‘", "'");
    result = result.replace("’", "'")
    return result;
}


function getSearchResults(queryNameLastNameStart, queryNameSort, isProgrammatic) {
    // Get the values of the selected filters
    var queryNameLevel = $("#TitleDropDown").val();
    var queryNameLicense = $("#LicenseDropDown").val();
    var queryNameLanguage = $("#LanguageDropDown").val();
    var queryNameIndustry = "";
    var queryNamePractice = "";
    var queryNameOffice = "";
    var queryNameKeyword = handleQuote($("#KeywordInput").val().trim());
    var queryNameLevelText = $("option:selected", "#TitleDropDown").text();
    var queryNameLicenseText = $("option:selected", "#LicenseDropDown").text();
    var queryNameLanguageText = $("option:selected", "#LanguageDropDown").text();
    var queryNameIndustryText = [];
    var queryNamePracticeText = [];
    var queryNameOfficeText = [];
    var div = $("#people-results-list");
    var divSelectedOptions = $("#search-criteria-results");

    var industryVanityNames = [];
    var practiceVanityNames = [];
    var officeVanityNames = [];


    // Loop through selected industries multilist
    $("#IndustryUl button.is-selected").each(function () {
        var dataIndustry = $(this).attr("data-filter");
        var dataName = $(this).attr("data-name");
        queryNameIndustry += dataIndustry + ";";
        queryNameIndustryText.push({
            key: dataIndustry,
            text: $(this).text()
        });
        industryVanityNames.push(dataName);
    });

    // Loop through selected practices multilist
    $("#PracticeUl button.is-selected").each(function () {
        var dataPractice = $(this).attr("data-filter");
        var dataName = $(this).attr("data-name");
        queryNamePractice += dataPractice + ";";
        queryNamePracticeText.push({
            key: dataPractice,
            text: $(this).text()
        });
        practiceVanityNames.push(dataName);
    });

    // Loop through selected offices multilist
    $("#OfficeUl button.is-selected").each(function () {
        var dataOffice = $(this).attr("data-filter");
        var dataName = $(this).attr("data-name");
        queryNameOffice += dataOffice + ";";
        queryNameOfficeText.push({
            key: dataOffice,
            text: $(this).text()
        });
        officeVanityNames.push(dataName);
    });

    // check the active letter
    if (queryNameLastNameStart === "") {
        var activeLetter = $("#list-alpha a.is-selected");
        if (activeLetter.length > 0) {
            queryNameLastNameStart = activeLetter.attr("data-filter");
        }
    }

    // check the active sort option
    if (queryNameSort === "") {
        var activeSortOption = $(".search-criteria-filter-item.is-active");
        if (activeSortOption.length > 0) {
            queryNameSort = activeSortOption.attr("data-filter");
        }
    }

    if (!isProgrammatic) {
        //push the record of this search to history
        router.state = {
            keyword: queryNameKeyword,
            letter: queryNameLastNameStart,
            industries: industryVanityNames,
            practices: practiceVanityNames,
            offices: officeVanityNames,
            level: queryNameLevelText,
            license: queryNameLicenseText,
            language: queryNameLanguageText,
            sort: queryNameSort,
            page: currentPage
        };
        router.push();
    }

    //back/forward button, or refresh: load all the results
    var loadAllUpToPage = (isProgrammatic);
    if (loadAllUpToPage) console.log('loading all results up to page ' + currentPage);

    // Check if all filters are empty
    if (queryNameKeyword === "" && queryNameLastNameStart === "" && queryNameIndustry.length === 0 && queryNamePractice.length === 0 && queryNameOffice.length === 0 && queryNameLevel === "" && queryNameLicense === "" && queryNameLanguage === "") {
        noFilterSelected();
    } else {
        $.ajax({
            url: "api/ProfessionalsSearchResults/GetSearchResults",
            type: "POST",
            data: { Keyword: queryNameKeyword, LastNameStart: queryNameLastNameStart, Industry: queryNameIndustry, Practice: queryNamePractice, Office: queryNameOffice, Level: queryNameLevel, License: queryNameLicense, Language: queryNameLanguage, Sort: queryNameSort, Page: currentPage, loadAllUpToPage: loadAllUpToPage },
            dataType: "text",
            success: function (datastring) {
                datastring = datastring.replace(/\0/g, '');
                var data = $.parseJSON(datastring);
                if (data.Results.length === 0) {
                    $("#search-criteria-filters").empty();
                    hideViewMoreButton();
                    div.html(noResultsMessage);
                } else {
                    if (data.HighIndex >= data.TotalItems) {
                        hideViewMoreButton();
                    }
                    $.each(data.Results, function (i, item) {
                        printPerson(div, item);
                    });
                }

                printSelectedOptions(queryNameKeyword, queryNameLastNameStart, queryNameIndustryText, queryNamePracticeText, queryNameOfficeText, queryNameLevelText, queryNameLicenseText, queryNameLanguageText, queryNameSort, divSelectedOptions);
                animateResults();
            },
            error: function (xhr, ajaxOptions, thrownError) {
                if (xhr.status === 200) {
                    hideViewMoreButton();
                    $("#people-results-list").html(noResultsMessage);
                    printSelectedOptions(queryNameKeyword, queryNameLastNameStart, queryNameIndustryText, queryNamePracticeText, queryNameOfficeText, queryNameLevelText, queryNameLicenseText, queryNameLanguageText, queryNameSort, divSelectedOptions);
                    animateResults();
                }
            }
        });
    }
}

function resetFilterLabels() {
    // Append count of selected filters to button text
    var activeIndustryFilters = $('#IndustryUl').children('li').children('button[class*=is-selected]').length;
    if (activeIndustryFilters > 0) {
        $('#IndustryButton').html('Industry (' + activeIndustryFilters + ')');
    } else {
        $('#IndustryButton').html('Industry');
    }

    var activePracticeFilters = $('#PracticeUl').children('li').children('button[class*=is-selected]').length;
    if (activePracticeFilters > 0) {
        $('#PracticeButton').html('Practice (' + activePracticeFilters + ')');
    } else {
        $('#PracticeButton').html('Practice');
    }

    var activeOfficeFilters = $('#OfficeUl').children('li').children('button[class*=is-selected]').length;
    if (activeOfficeFilters > 0) {
        $('#OfficeButton').html('Office (' + activeOfficeFilters + ')');
    } else {
        $('#OfficeButton').html('Office');
    }
}

function getDropdownByText(selector, value) {
    return $(selector).filter(function () { return $(this).text() == value })
}


(function ($) {
    'use strict';

    //On DOM Ready
    $(function () {

        //Find All Toggle Components and attach event handler
        var $filterOptions = $('[data-filter-options]');

        //check to see if we have any accordions on the page, if so attach event handler
        if ($filterOptions.length > 0) {
            filterOptionsInit($filterOptions);
        }

        function filterOptionsInit($filterOptions) {

            $filterOptions.on('click.filterOptions', '.filter-accordion-link', function () {
                var _self = $(this);

                if (_self.hasClass('is-selected')) {
                    _self.removeClass('is-selected');
                }
                else {
                    _self.addClass('is-selected');
                    $filterOptions.find('.is-active-menu').trigger('click');
                }

                resetFilterLabels();
                resetSearchResults();
                resetViewMoreButton();
                getSearchResults("", "");
            });
        }
    });

})(jQuery);